export const colors = {
  primaryDark: "#203647",
  primaryMain: "#46769a",
  primaryLight: "#7494b7",
  primaryPale: "#d8e4ed",
  secondaryDark: "#313132",
  secondaryMain: "#535355",
  secondaryLight: "#8e8e90",
  secondaryPale: "#e0e0e4",
  successDark: "#3b4f2a",
  successMain: "#7cb54e",
  successLight: "#98c375",
  successPale: "#e1edd7",
  warningDark: "#4d4020",
  warningMain: "#eca900",
  warningLight: "#f1c044",
  warningPale: "#fceaba",
  dangerDark: "#4d202b",
  dangerMain: "#b5183f",
  dangerLight: "#cb5271",
  dangerPale: "#ebc3cd",
  blueBerryDark: "#3a3062",
  blueBerryMain: "#5e4fa2",
  blueBerryLight: "#aea7d0",
  blueBerryPale: "#d7d3e8",
  windowsBlueDark: "#123144",
  windowsBlueMain: "#3288bd",
  windowsBlueLight: "#84b8d7",
  windowsBluePale: "#cce1ee",
  paleTealDark: "#204f40",
  paleTealMain: "#66c2a5",
  paleTealLight: "#9bd7c4",
  paleTealPale: "#d1ece4",
  lipstickDark: "#4c0e28",
  lipstickMain: "#b3215d",
  lipstickLight: "#d88fae",
  lipstickPale: "#e3bbcc",
  fadedOrangeDark: "#722007",
  fadedOrangeMain: "#f57f5b",
  fadedOrangeLight: "#f57f5b",
  fadedOrangePale: "#fbd2c6",
  oliveGreenDark: "#4c5b1e",
  oliveGreenMain: "#a9c44f",
  oliveGreenLight: "#cbdb96",
  oliveGreenPale: "#e9f0d3",
  butterScotchDark: "#775a02",
  butterScotchMain: "#fbc938",
  butterScotchLight: "#fcdc7d",
  butterScotchPale: "#fff1c8",
  darkishPinkDark: "#670f1a",
  darkishPinkMain: "#e54658",
  darkishPinkLight: "#ef909b",
  darkishPinkPale: "#f4cfd3",
  textDefault: "#292524",
  iconDefault: "#56514d",
  textSecondary: "#797c80",
  formInputBorder: "#dddddd",
  formPlaceholder: "#a9a29e",
  disabledBackground: "#fafaf9",
  disabledColor: "#a8a29e",
  disabledBorder: "#e7e5e4",
  lightBackground: "#ffffff",
  panelBackground: "#fafafa",
  selectStroke: "#4d90fe",
  selectedRow: "#eaf3ff",
};
